import { createStripeCustomer } from "./api";
export const getOrCreateStripeCustomer = async (userId) => {
    return await createStripeCustomer(userId)
  };
